import React, { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { Search, Filter } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";
import TableComponent from "../../../shared/components/table";
import { AppealAssignedColumns } from "../../../shared/components/table/columns/appealAssigned";
import { SortingState } from "@tanstack/react-table";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  openCaseModal,
  setCaseDetailModal,
} from "../../../states/slices/globalReducer";
import CaseFolderDetailsModal from "./case-folder/modals/CaseFolderDetailsModal";

const MOCK_DATA = [
  {
    sn: false,
    date: "30 April 2021",
    appeal_number: "CV/3047/2018",
    title: "Olugbenga Akintola vs Israel Anyemalu",
    court: "Hon. A. Eze Jsc.",
    court_number: "Court 5",
    panel: "1",
  },
  {
    sn: false,
    date: "30 April 2021",
    appeal_number: "CV/3047/2018",
    title: "Olugbenga Akintola vs Israel Anyemalu",
    court: "Hon. A. Eze Jsc.",
    court_number: "Court 5",
    panel: "2",
  },
  {
    sn: false,
    date: "30 April 2021",
    appeal_number: "CV/3047/2018",
    title: "Olugbenga Akintola vs Israel Anyemalu",
    court: "Hon. A. Eze Jsc.",
    court_number: "Court 5",
    panel: "1",
  },
];

const filterOptions = ["All cases", "Pending cases", "Completed cases"];

function AppealAssignedNo() {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("All cases");
  const showCaseFolderDetails = useAppSelector(openCaseModal);
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col h-full min-h-screen ">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB]">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-[28px] font-bold text-[#1A1A1A]">
            Appeal number
          </h1>
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="flex items-center gap-x-2 border border-[#E9EAEB] px-4 py-2 rounded-lg text-sm font-medium text-[#344054] hover:bg-gray-50 transition-colors bg-white shadow-sm">
              <Filter className="w-4 h-4" />
              <span>{activeFilter}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-10">
                <div className="px-1 py-1">
                  {filterOptions.map((option) => (
                    <Menu.Item key={option}>
                      {({ active }) => (
                        <button
                          onClick={() => setActiveFilter(option)}
                          className={`${
                            active
                              ? "bg-[#E6F7F1] text-[#00B074]"
                              : "text-gray-900"
                          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                        >
                          {option}
                        </button>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <div className="flex items-center gap-x-2 text-sm text-[#475467]">
          <Link
            to="/registrar1-payment/assigned-appeal"
            className="hover:text-[#00B074] transition-colors"
          >
            Home
          </Link>
          <span className="text-[#D0D5DD]">{">"}</span>
          <span className="font-medium text-[#1A1A1A]">Appeal number</span>
        </div>
      </div>

      {/* Content */}
      <div className="p-8 flex flex-col gap-y-6">
        {/* Search */}
        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] focus:ring-1 focus:ring-[#00B074] bg-white text-sm placeholder:text-[#667085] shadow-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
        </div>

        {/* Table */}
        <div className="bg-white  overflow-hidden">
          <TableComponent
            DATA={MOCK_DATA}
            // @ts-ignore
            COLUMNS={AppealAssignedColumns}
            sorting={sorting}
            setSorting={setSorting}
          />

          {/* Pagination */}
          <div className="flex items-center justify-end gap-x-4 mt-6 text-sm text-[#464255]">
            <span>Page 1 of 10</span>
            <div className="flex items-center gap-x-2">
              <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                Previous
              </button>
              <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                Next
              </button>
            </div>
            <div className="flex items-center gap-x-2">
              <span>Entries per page:</span>
              <select className="border border-[#E9EAEB] rounded p-1 focus:outline-none">
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <CaseFolderDetailsModal
        open={showCaseFolderDetails || false}
        close={() => dispatch(setCaseDetailModal(false))}
      />
    </div>
  );
}

export default AppealAssignedNo;
